import { render, staticRenderFns } from "./HomeSiparisDetay.vue?vue&type=template&id=1ed4b84d&"
import script from "./HomeSiparisDetay.vue?vue&type=script&lang=js&"
export * from "./HomeSiparisDetay.vue?vue&type=script&lang=js&"
import style0 from "./HomeSiparisDetay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports